import { Table } from 'components/shared';
import type { Form } from 'types';

import { FormsTableFiltersRow } from './FormsTableFiltersRow';
import { FormsTableHeadRow } from './FormsTableHeadRow';
import { FormsTableItemRow } from './FormsTableItemRow';
import { applyTableStyles } from './styles';

type Props = {
  forms: Form[];
};

export const FormsTable = ({ forms }: Props) => {
  return (
    <Table sx={applyTableStyles}>
      <thead>
        <FormsTableHeadRow />
      </thead>
      <tbody>
        {forms.length > 0 && <FormsTableFiltersRow />}
        {forms.map(form => (
          <FormsTableItemRow key={form.id} form={form} />
        ))}
      </tbody>
    </Table>
  );
};
